import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Paragraph } from "../basic/title";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';


const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;
const DEFAULT_IMAGE = 'path_to_default_image.jpg';

const settings = {
    infinite: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

const CollectionsShopCard = ({ allproducts }) => {
    const navigate = useNavigate();
    const [topPurchasedProducts, setTopPurchasedProducts] = useState([]);
    const [selectedVariantDetails, setSelectedVariantDetails] = useState({});
    const [selectedVariants, setSelectedVariants] = useState({});
    const [wishlistIds, setWishlistIds] = useState([]);

    useEffect(() => {
      if(allproducts?.length) {
        let sorted = allproducts
          .filter(item => item.purchase_count && item.purchase_count > 0)
          .sort((a, b) => b.purchase_count - a.purchase_count);
        if(sorted.length === 0) {
          sorted = allproducts.slice(0, 2);
        }
    
        setTopPurchasedProducts(sorted);
      }
    }, [allproducts]);

    useEffect(() => {
        const variants = {};
        const variantDetails = {};
        allproducts?.forEach(product => {
            const allVariants = product.variant_value?.flatMap(v => v.multiple_values) || [];
            const firstInStockVariant = allVariants.find(variant => variant.stock_quantity > 0);
            const variantToSelect = firstInStockVariant || allVariants[0];
            if (variantToSelect) {
                variants[product.id] = variantToSelect.id;
                variantDetails[product.id] = variantToSelect;
            }
        });

        setSelectedVariants(variants);
        setSelectedVariantDetails(variantDetails);
    }, [allproducts]);

    const handleDetailsRow = (id) => {
        navigate(`/shop/${id}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

return (
  <Slider {...settings}>
    {topPurchasedProducts.map((item, index) => (
      <div className="group relative h-full" key={index}>
        <div className="group flex flex-col justify-center relative h-full items-center rounded-br-lg rounded-tl-lg border-2 border-[#072320]">
          <div
            className="flex justify-center items-center cursor-pointer bg-[#00A762] rounded-br-lg rounded-tl-lg m-4 p-4 relative w-full"
            onClick={() => handleDetailsRow(item?.id)}
          >
            <div className="relative overflow-hidden h-[200px] w-full rounded-br-lg rounded-tl-lg image-container">
              <img
                src={
                  BASE_IMAGE_URL +
                  (Array.isArray(item?.additional_images) && item?.additional_images.length > 0
                    ? item?.additional_images[0]
                    : DEFAULT_IMAGE)
                }
                alt="Product"
                className="block w-full h-full transition-all duration-300 ease-in-out group-hover:opacity-0 zoom-image"
              />
              <img
                src={
                  BASE_IMAGE_URL +
                  (Array.isArray(item?.additional_images) && item?.additional_images.length > 0
                    ? item?.additional_images[0]
                    : DEFAULT_IMAGE)
                }
                alt="Product"
                className="block w-full h-full opacity-0 absolute top-0 left-0 transition-all duration-300 ease-in-out group-hover:opacity-100"
              />
            </div>

          </div>

          <div className="flex flex-col justify-center items-center mt-2 mb-4">
            <h2
              className="text-[#00A762] text-center font-dm text-lg capitalize font-medium cursor-pointer"
              onClick={() => handleDetailsRow(item?.id)}
            >
              {item?.name}
            </h2>
            <div>
              <Paragraph title={item?.short_description} shortDescription="true" lineclamp="3" />
            </div>
          </div>
        </div>
      </div>
    ))}
  </Slider>
);

};

export default CollectionsShopCard;
